import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
// import classNames from 'classnames';
import PullToRefresh from 'react-simple-pull-to-refresh';
import PropTypes from 'prop-types';
import moment from 'moment';
import Media from 'react-media';
import queryString from 'query-string';

import { urlParam } from '../../helpers/utils';
import {
  initMultiLivePage, changeSelectedCompetition, getMatchesFacts, getLives,
} from '../../services/live';
import { setCurrentDate, setMultiLiveDate, setDate } from '../../actions/liveActions';
import { setFixedHeader, setActiveSection } from '../../actions/appActions';
import ModalDigest from '../ModalDigest';
import useInterval from '../../hooks/useSetInterval';

import s from './style.module.scss';

const PageDigest = ({
  actions, live, router,
}) => {
  const [open, setOpen] = useState(true);
  const queryParams = queryString.parse(router.location.search);
  const divisions = urlParam('divisions');
  const matchs = urlParam('matchs');
  const fromUrlParam = urlParam('from');
  const arrayDivisions = divisions != null ? divisions.split(',') : [];
  const arrayMatchs = matchs != null ? matchs.split(',') : [];
  const selected = {
    arrayDivisions,
    arrayMatchs,
  };
  const [selectedParams] = useState(selected);
  const isIframe = queryParams.iframe === 'true';
  const dateFromUrl = queryParams.date;

  useEffect(() => {
    // eslint-disable-next-line prefer-regex-literals
    const regex = RegExp(/^\d{4}-\d{2}-\d{2}$/);
    if (dateFromUrl !== null && regex.test(dateFromUrl) && dateFromUrl !== live.date) {
      actions.setDate(dateFromUrl);
    }
  }, []);

  useEffect(() => {
    actions.setActiveSection('live');
    actions.setFixedHeader(true);
    if ((live.date !== live.currentDate || live.multiLive.actions.length === 0)
      && !live.isLoading) {
      actions.setCurrentDate(live.date);
      actions.initMultiLivePage(selected, fromUrlParam !== null
        ? fromUrlParam
        : false, live.date, isIframe);
    }
    return () => actions.setFixedHeader(false);
  }, [live.date]); // eslint-disable-line

  useInterval(() => {
    live.multiLive.liveCompetitions.map((c) => actions.getLives(selectedParams, c.type, 'multiLive'));
    actions.getMatchesFacts(true);
  }, live.multiLive.isLive ? 15000 : null);

  const handleRefresh = () => {
    actions.initMultiLivePage(
      selected,
      fromUrlParam !== null ? fromUrlParam : false,
      live.date,
      isIframe,
    );
  };

  //   function openModal(mobile) {
  //     if (mobile) {
  //       setOpen(true);
  //     } else {
  //       window.scrollTo(0, 0);
  //       setOpen(true);
  //     }
  //   }

  // const handleCompetitionChange = (e) => {
  //   // eslint-disable-next-line no-shadow
  //   const [type, d] = e.target.value.split('-|-');
  //   const compet = live[type].competitions.find((c) => c.division === d);
  //   actions.changeSelectedCompetition(compet, type);
  //   router.push(
  //     '/multilive/[championship]/[division]',
  // eslint-disable-next-line max-len
  //     `/multilive/${encodeURI(compet.championship).replace('/', '%2F')}/${encodeURI(compet.division).replace('/', '%2F')}?from=${type}`,
  //   );
  // };

  // if (championship === 'undefined' || championship === undefined) {
  //   return router.push('/live');
  // }

  return (
    <Media queries={{
      small: '(max-width: 720px)',
    }}
    >
      {(matches) => (
        <div
          className={s.container}
          // eslint-disable-next-line no-nested-ternary
          style={{ marginTop: matches.small && !isIframe ? 100 : 0 }}
        >
          <PullToRefresh onRefresh={handleRefresh}>
            {/* <ScrollCalendar className={
            classNames(s.container__calendar, isIframe ? s.container__calendar__iframe : undefined)
            }
            /> */}
            {/* {isIframe
              && (
                open && (
                  <div
                    className={s.container__division}
                    style={{ marginTop: matches.small ? 34 : 0 }}
                  >
                    {live.selectedCompetition?.division}
                  </div>
                )
              )} */}

            {/* {!open && (
            <div className={
              classNames(s.container__header, isIframe ? s.container__header__iframe : undefined)
              }
            >
              <div
                onClick={() => openModal(matches.small)}
                onKeyPress={() => openModal(matches.small)}
                role="presentation"
                className={s.container__header__resume}
              >
                {live.date === moment().format('YYYY-MM-DD') && <b>En direct</b>}
                <span>Voir le résumé</span>
              </div>
              <div className={s.container__header__time}>
                {live.liveDate}
              </div>
            </div>
            )} */}
            <ModalDigest
              open={open}
              competition={live.selectedCompetition !== undefined
                ? live.selectedCompetition.division : ''}
              date={moment(live.currentDate).format('LL')}
              close={() => setOpen(false)}
              games={live.multiLive.matches}
              actions={live.multiLive.actions}
              isIframe={isIframe}
              digest
            />
            {!open && (
              <div>
                <br />
                <br />
              </div>
            )}
          </PullToRefresh>
        </div>
      )}
    </Media>
  );
};

PageDigest.propTypes = {
  actions: PropTypes.shape({
    setFixedHeader: PropTypes.func.isRequired,
    initMultiLivePage: PropTypes.func.isRequired,
    setCurrentDate: PropTypes.func.isRequired,
    changeSelectedCompetition: PropTypes.func.isRequired,
    setMultiLiveDate: PropTypes.func.isRequired,
    getLives: PropTypes.func.isRequired,
    getMatchesFacts: PropTypes.func.isRequired,
    setDate: PropTypes.func.isRequired,
    setActiveSection: PropTypes.func.isRequired,
  }).isRequired,
  live: PropTypes.any.isRequired,
  router: PropTypes.any.isRequired,
};

const mapStateToProps = (state) => {
  const { live } = state.entities;
  const { router } = state;
  return {
    live,
    router,
  };
};

const mapDispatchToProps = (dispatch) => ({
  actions: {
    setFixedHeader: bindActionCreators(setFixedHeader, dispatch),
    initMultiLivePage: bindActionCreators(initMultiLivePage, dispatch),
    setCurrentDate: bindActionCreators(setCurrentDate, dispatch),
    changeSelectedCompetition: bindActionCreators(changeSelectedCompetition, dispatch),
    setMultiLiveDate: bindActionCreators(setMultiLiveDate, dispatch),
    getLives: bindActionCreators(getLives, dispatch),
    getMatchesFacts: bindActionCreators(getMatchesFacts, dispatch),
    setDate: bindActionCreators(setDate, dispatch),
    setActiveSection: bindActionCreators(setActiveSection, dispatch),
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PageDigest);
